var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v("Une erreur s'est produite. La facture n'a été envoyée à personne.")]):_vm._e(),_c('div',{staticClass:"mb-2"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading,"depressed":"","large":"","color":"primary"},on:{"click":_vm.envoyerFacture}},[_vm._v("Envoyer la facture")]),_c('router-link',{attrs:{"to":{
        name: 'patients.show',
        params: {
          id: _vm.$route.params.id,
        },
      }}},[_c('v-btn',{staticClass:"ml-3",attrs:{"disabled":_vm.loading,"loading":_vm.loading,"depressed":"","large":""}},[_vm._v("Passer")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }